<main class="grid h-screen min-h-full items-center bg-white">
    @if(instagramAccount) {
    <div class="relative sm:max-w-xl sm:mx-auto">
        <div
            class="absolute inset-0 custom-gradient transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl shadow-lg">
        </div>
        <div class="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">

            <div class="mx-auto w-full max-w-sm lg:w-96">

                <div class="flex items-center gap-x-6">
                    <img class="size-16" src="../../../assets/instagram.webp" alt="" />
                    <div>
                        <h3 class="text-2xl/9 font-bold tracking-tight text-gray-900">Instagram</h3>
                        <p class="text-sm/6 font-semibold text-fuchsia-600">Account Connected</p>
                    </div>
                </div>

                <div class="mt-10 flex flex-col gap-y-4 items-center justify-center">
                    <img class="mx-auto size-24 rounded-full" [src]="instagramAccount.profile_picture_url" alt="" />
                    <h3 class="text-2xl/9 font-semibold tracking-tight text-gray-900">
                        {{instagramAccount.name}}</h3>


                    <dl class="grid grid-cols-3 gap-0.5 overflow-hidden rounded-2xl text-center">
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Followers</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(instagramAccount.followers_count)}}</dd>
                        </div>
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Following</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(instagramAccount.follows_count)}}</dd>
                        </div>
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Videos</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(instagramAccount.media_count)}}</dd>
                        </div>
                    </dl>

                    <div class="w-full flex flex-row justify-between gap-x-4 items-center">

                        <button (click)="exitBrowser()" type="button"
                            class="rounded bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Exit</button>

                        <button type="button" (click)="connectAnotherAccount()"
                            class="inline-flex items-center gap-x-1.5 rounded-md bg-fuchsia-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-fuchsia-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fuchsia-600">
                            Connect Another Account
                            <svg class="-mr-0.5 size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
                                data-slot="icon">
                                <path fill-rule="evenodd"
                                    d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>

                </div>
            </div>

        </div>
    </div>
    } 
    @else {
    <div class="text-center items-center">
        <h1>Error</h1>
        <p>Something went wrong</p>
    </div>
    }
</main>